import * as types from './types';
export default {
  setAbTestToggleState: function setAbTestToggleState(_ref, state) {
    var commit = _ref.commit;
    commit(types.SEND_ABTEST_TOGGLE, state);
  },
  setAbTestToggleTooltyState: function setAbTestToggleTooltyState(_ref2, state) {
    var commit = _ref2.commit;
    commit(types.SEND_ABTEST_TOOLTYPE_TOGGLE, state);
  }
};